import { render } from "./LDNs.vue?vue&type=template&id=3e936e15&scoped=true&ts=true"
import script from "./LDNs.vue?vue&type=script&lang=ts"
export * from "./LDNs.vue?vue&type=script&lang=ts"

import "./LDNs.vue?vue&type=style&index=0&id=3e936e15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e936e15"]])

export default __exports__